module.exports = "<div class=\"inspirationDetail text-left\">\r\n    <oly-dynamic-content\r\n        schedule-key=\"$ctrl.scheduleKey\"\r\n        onload=\"$ctrl.onload()\">\r\n    </oly-dynamic-content>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/inspiration/detail/inspiration-detail.component.html
// module id = 1000
// module chunks = 0